export const DEFAULT_STATUS_MESSAGES = {
    400: 'Invalid request data',
    401: 'Authentication required',
    403: 'Insufficient permissions',
    404: 'Resource not found',
    429: 'Too many requests. Try again later',
    500: 'Server error',
    502: 'Server temporarily unavailable',
    503: 'Service temporarily unavailable',
};
export const DEFAULT_OVERRIDES = {
    networkError: 'Network connection error',
    unknownError: 'An unknown error occurred',
    authEventMessage: 'Session expired, please sign in again',
    serverErrorTitle: 'Server error',
    serverErrorMessage: 'A server error occurred. Please try again later.',
    clientErrorTitle: 'Error',
};
export const DEFAULT_CONFIG = {
    logToConsole: true,
    logToStorage: true,
    maxStoredErrors: 50,
    showUserNotifications: true,
    skipAuthErrors: false,
};
